import { Link } from "components/Link";
import { MaxWidth } from "components/MaxWidth";
import { SrcSet } from "components/SrcSet";
import styles from "./PeopleHero.module.css";

export const PeopleHero = ({ image, jobTitle, label, link, title }) => (
  <div className={styles.container}>
    <MaxWidth>
      <div className={styles.flex}>
        {image?.src && (
          <SrcSet
            alt={image.alt}
            className={styles.image}
            cropCenter
            sizes={[
              { minWidth: 1024, width: 160, ratio: 1 },
              { minWidth: 1, width: 130, ratio: 1 },
            ]}
            src={image.src}
          />
        )}
        <div>
          <Link {...link} className={styles.label}>
            {label}
          </Link>
          <h1 className={styles.title}>{title}</h1>
          <div className={styles.jobTitle}>{jobTitle}</div>
        </div>
      </div>
    </MaxWidth>
  </div>
);
